import { render, staticRenderFns } from "./sDataBanckingEdit.vue?vue&type=template&id=3651a931"
import script from "./sDataBanckingEdit.vue?vue&type=script&lang=js"
export * from "./sDataBanckingEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports